import { Validator } from 'utils';
import * as Yup from 'yup';

export class UpdateOrderValidator {
  public get schema() {
    return Yup.object().shape({
      driverName: Yup.string()
        .trim()
        .required('Informe o nome do motorista')
        .max(50, 'Nome de motorista inválido')
        .test(
          'singleDriver',
          'Nome de motorista inválido',
          (value) => !/[/\\,;&+\d]/.test(value ?? '')
        ),
      driverDocument: Yup.mixed().test({
        name: 'testDocument',
        test: function (value: string) {
          try {
            Validator.validateDocument(value, 'cpf');
            return true;
          } catch (error: any) {
            return this.createError({
              message: error?.message,
            });
          }
        },
      }),
      vehiclePlate: Yup.string()
        .trim()
        .required('Informe a placa do veículo')
        .matches(
          /^(?:[A-Z]{3}\d[A-Z0-9]\d{2}|[A-Z]{2}\d{3}[A-Z]{2}|[A-Z]{3}\d{3}|[A-Z]{4}\d{2,3}|\d{4}[A-Z]{3})$/i,
          'Informe uma única placa válida (ex.: ABC1D23)'
        ),
      cellPhone: Yup.string().min(11, 'Número inválido').optional(),
      date: Yup.string().required('Informe a data do agendamento'),
      dockAndTimeFrame: Yup.string().required('Informe a doca'),
      // Valida os documentos editados por linha no modal.
      items: Yup.array().of(
        Yup.object().shape({
          document: Yup.string().required('Informe o número do documento'),
        })
      ),
    });
  }
}
